import { makeEnumClass } from '../base-enum';

export class TipoFeriasEspecialEnum extends makeEnumClass() {
    static readonly ADMINISTRATIVO_SEM_PARCELAS = TipoFeriasEspecialEnum.add('ASP', 'Administrativas sem Parcelas', {
        nomeBackend: 'ADMINISTRATIVO_SEM_PARCELAS',
        textoAlternativo: 'Férias Especiais Administrativas sem Parcelas'
    });
    static readonly JUDICIAL_SEM_PARCELAS = TipoFeriasEspecialEnum.add('JSP', 'Judiciais sem Parcelas', {
        nomeBackend: 'JUDICIAL_SEM_PARCELAS',
        textoAlternativo: 'Férias Especiais Judiciais sem Parcelas'
    });
    static readonly ADMINISTRATIVO_COM_PARCELAS = TipoFeriasEspecialEnum.add('ACP', 'Administrativas com Parcelas', {
        nomeBackend: 'ADMINISTRATIVO_COM_PARCELAS',
        textoAlternativo: 'Férias Especiais Administrativas com Parcelas'
    });
    static readonly JUDICIAL_COM_PARCELAS = TipoFeriasEspecialEnum.add('JCP', 'Judiciais com Parcelas', {
        nomeBackend: 'JUDICIAL_COM_PARCELAS',
        textoAlternativo: 'Férias Especiais Judiciais com Parcelas'
    });
    static readonly JUDICIAL_COM_PARCELAS_POS_MIGRACAO = TipoFeriasEspecialEnum.add('JMI', 'Judiciais com Parcelas pós Migração', {
        nomeBackend: 'JUDICIAL_COM_PARCELAS_POS_MIGRACAO',
        textoAlternativo: 'Férias Especiais Judiciais com Parcelas pós Migração'
    });

    /**
     * Resolve a modalidade persistida aceitando tanto o código (`ACP`) quanto o nome
     * do enum do backend (`ADMINISTRATIVO_COM_PARCELAS`).
     */
    static fromCodigoOuNome(valor: string): TipoFeriasEspecialEnum {
        if (!valor) {
            return null;
        }

        const valorNormalizado = valor.trim().toUpperCase();
        return (TipoFeriasEspecialEnum.all.find(tipo => tipo.id === valorNormalizado || tipo.extras?.nomeBackend === valorNormalizado) as TipoFeriasEspecialEnum) ?? null;
    }
}
